import { ready } from './vendor/brei-project-utils.js';

import { aditl } from './modules/a-day-in-the-life';
import { profile } from './modules/profile';

const detail = {
	init() {
		aditl.init();
		profile.init();
	}
};

ready(function () {
	detail.init();
});
